<template>
  <component
    :is="routeTo ? 'router-link' : 'div'"
    :to="routeTo"
    :class="setClass()"
    class="custom-btn"
    @click="onClick"
  >
    <div
      v-if="!img || !text"
      class="pointer-events-none"
      style="display: flex; justify-content: center; align-items: center; gap: 10px;"
    >
      <div v-if="!img">
        {{ text }}
      </div>
      <img
        v-else
        :src="require(`../../assets/${img}`)"
        :alt="altImg"
      >      
      <slot name="badge" />
    </div>
    <div
      v-else-if="(img || text) && !$slots.text"
      style="display: flex; justify-content: center; align-items: center;"
      class="pointer-events-none"
    >
      <img
        :src="require(`../../assets/${img}`)"
        :alt="altImg"
        style="top: 0; padding-right: 6px;"
      >
      <div> {{ text }}</div>
    </div>
    <slot name="text" />
  </component>
</template>

<script>
export default {
  name: "Button",
  props: {
    routeTo: {
      type: Object,
      default: null,
    },
    text: {
      type: String,
      default: "Button",
    },
    img: {
      type: String,
    },
    typeClass: {
      type: String,
      validator: val => ["red", "outline-red", "green", "yellowgold", "outline-tr", "disable", "black", "indigo-dark", "outline-black", "outline-gray"].includes(val),
      default: "red",
    },
    customPadding: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    round: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      altImg: "logo-btn.png"
    }
  },
  methods: {
    onClick(event) {
      if (!this.disabled) {
        this.$emit('click', event)
      }
    },
    setClass() {
      if (this.customPadding) {
        if (this.disabled) {
          return "custom-padding " + this.typeClass + " disabled"
        }
        return "custom-padding " + this.typeClass
      }
      if (this.disabled) {
        return this.typeClass + " disabled"
      }

      if (this.round) {
        return this.typeClass + " round"
      }
      return this.typeClass
    }
  }
}
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>
